import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_WORKLOADS_SUMMARY_QUERY_KEY = 'woop-workloads-summary';

export const getWorkloadsOptimizationSummaryQueryKey = ({
  clusterId,
}: { clusterId?: string } = {}) =>
  [WOOP_WORKLOADS_SUMMARY_QUERY_KEY, clusterId] as const;

type UseWorkloadsOptimizationSummaryQueryArgs = {
  clusterId: string;
  enabled?: boolean;
};

export const getWorkloadsOptimizationSummaryQueryOptions = ({
  clusterId,
  enabled = true,
}: UseWorkloadsOptimizationSummaryQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadsOptimizationSummaryQueryKey({ clusterId }),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getWorkloadsOptimizationSummary({
          clusterId,
          includeCosts: true,
        });
      return data;
    },
    enabled,
  });

export const useWorkloadsOptimizationSummaryQuery = (
  args: UseWorkloadsOptimizationSummaryQueryArgs
) => {
  const { isLoading, data, error, refetch, isRefetching } = useQuery(
    getWorkloadsOptimizationSummaryQueryOptions(args)
  );

  return { isLoading, isFetching: isRefetching, error, refetch, data };
};
